// extracted by mini-css-extract-plugin
export var sm = "768";
export var md = "1024";
export var lg = "1280";
export var xl = "1600";
export var wrapper = "MiscellaneousInformationTitle-module--wrapper--8LXI5";
export var awards = "MiscellaneousInformationTitle-module--awards--loq+4";
export var profAssociations = "MiscellaneousInformationTitle-module--profAssociations--uH3nF";
export var iconWrapper = "MiscellaneousInformationTitle-module--iconWrapper--hVtyb";
export var label = "MiscellaneousInformationTitle-module--label--P+0wo";